module.exports = __webpack_public_path__ + "static/media/Bruce_Barren.1c16ffdd.png";